import { errHof, httpPost } from "@/http"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const markAnnouncementsSeen = createAsyncThunk(
  "welcome/user/markAnnouncementsSeen",
  async (opts = {}, { rejectWithValue, signal }) => {
    const { onSuccess, onError } = opts

    try {
      return await httpPost(
        "announcements",
        {},
        {
          signal,
          success: onSuccess,
          error: onError ?? errHof(onError, "markAnnouncementsSeen", rejectWithValue),
        },
      )
    } catch (err) {
      rejectWithValue(err)
    }
  },
)
